export default __webpack_public_path__ + "static/media/calendar-icon.b22dbecb.svg";